import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { RadioItem } from '@app/shared/ui/atoms/Admin';
import { cn } from '@app/shared/utils/common';
import { Page } from '@app/routes';

export type HeaderLinkType = 'balance' | 'withdrawals' | 'users' | 'matrix-channel-form';

interface HeaderLinkProps {
  type: HeaderLinkType;
}

const TYPE_MAP: Record<HeaderLinkType, { path: string; translationKey: string; icon: string }> = {
  balance: { path: Page.ADMIN_BALANCE, translationKey: 'balance', icon: '💎' },
  withdrawals: { path: Page.ADMIN_WITHDRAWALS, translationKey: 'withdrawals', icon: '💳' },
  users: { path: Page.ADMIN_USERS, translationKey: 'users', icon: '👥' },
  'matrix-channel-form': {
    path: Page.ADMIN_MATRIX_CHANNEL_FORM,
    translationKey: 'matrix_channel_form',
    icon: '📝',
  },
};

export function HeaderLink({ type }: HeaderLinkProps) {
  const { t } = useTranslation();
  const { path, translationKey, icon } = TYPE_MAP[type];

  return (
    <NavLink
      to={path}
      className={({ isActive }) =>
        cn(isActive && 'rounded-full bg-blue-light text-secondary-foreground')
      }
    >
      <RadioItem label={t(`admin_header.${translationKey}`)} icon={icon} />
    </NavLink>
  );
}
